'use client'

/**
 * Homepage
 * Route: /
 *
 * Features:
 * - Show Login/Register buttons if not authenticated
 * - Redirect to dashboard if already authenticated
 */

import React, { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useAuth } from '../context/AuthContext'
import LoadingSpinner from '../components/LoadingSpinner'
import InstallCommand from '../components/InstallCommand'

export default function HomePage() {
  const router = useRouter()
  const { isAuthenticated, isInitialized } = useAuth()

  useEffect(() => {
    if (!isInitialized) return

    if (isAuthenticated) {
      router.push('/dashboard')
    }
  }, [isAuthenticated, isInitialized, router])

  if (!isInitialized) {
    return <LoadingSpinner />
  }

  return (
    <div className="sc-hero">
      <div className="sc-hero-content">
        {/* Logo */}
        <div className="sc-hero-logo">
          <span style={{ fontSize: '0.875rem' }}>CCM</span>
        </div>

        <h1 className="sc-hero-title">CCMakers Code</h1>
        <p className="sc-hero-subtitle">&gt; multi-user authentication platform_</p>

        {/* One-line installer */}
        <div style={{ margin: '1.5rem 0', width: '100%', display: 'flex', justifyContent: 'center' }}>
          <InstallCommand />
        </div>

        {/* CTA buttons */}
        <div className="sc-hero-cta">
          <a href="/register" className="btn-cmd" style={{ padding: '0.875rem 2.5rem', fontSize: '1rem' }}>
            $ register --new-user
          </a>
          <span className="sc-hero-divider">// or</span>
          <a href="/login" className="btn-glass" style={{ padding: '0.75rem 2.5rem', fontSize: '0.875rem' }}>
            &gt; login --existing
          </a>
        </div>

        {/* Feature highlights */}
        <div className="sc-hero-features">
          <div className="sc-hero-feature">
            <span className="sc-hero-feature-dot sc-hero-feature-dot--green"></span>
            Secure Auth
          </div>
          <div className="sc-hero-feature">
            <span className="sc-hero-feature-dot sc-hero-feature-dot--cyan"></span>
            API Key Management
          </div>
          <div className="sc-hero-feature">
            <span className="sc-hero-feature-dot sc-hero-feature-dot--amber"></span>
            Rate Limiting
          </div>
        </div>
      </div>
    </div>
  )
}
